/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import { sumBy } from 'lodash';

import Date from '../../../common/date';
import Money from '../../../common/money';

const actionsMap = {
  newInventory: 'New Inventory',
  damaged: 'Damaged',
  stockTaking: 'Stock Taking',
  returned: 'Returned',
  retail: 'Retail',
  backbar: 'Backbar',
  other: 'Other',
};

export default items => [
  {
    Header: 'Date',
    accessor: 'dateTime',
    className: 'u-text-left',
    Cell: ({ value }) => <Date>{value}</Date>,
    Footer: 'Total',
  },
  {
    Header: 'Product name',
    accessor: 'productName',
  },
  {
    Header: 'SKU',
    accessor: 'productSku',
  },
  {
    Header: 'Brand',
    accessor: 'productBrand',
  },
  {
    Header: 'Category',
    accessor: 'productCategory',
  },
  {
    Header: 'Previous inventory',
    accessor: 'previousInventory',
  },
  {
    Header: 'New inventory',
    accessor: 'newInventory',
  },
  {
    Header: 'Supply price',
    accessor: 'supplyPrice',
    Cell: ({ value }) => <Money>{value}</Money>,
  },
  {
    id: 'total',
    Header: 'Total',
    Footer: () => <Money>{sumBy(items, 'total')}</Money>,
    accessor: 'total',
    Cell: ({ value }) => <Money>{value}</Money>,
  },
  {
    Header: 'Action',
    accessor: 'action',
    Cell: ({ value }) => actionsMap[value],
  },
  {
    Header: 'Description',
    accessor: 'description',
    minWidth: 200,
    Cell: ({ value }) => <div className="u-ws-normal">{value}</div>,
  },
];
